import * as images from "@/components/images/Images";
import { CasesCardProps } from "@/components/screen/global-components/cases/CasesCard";

const useCasesCardsContent = {
  title: "Translators specialized in your use case",
  description:
    "To ensure accurate, context-aware precision for even the most technical and complex professional business translations, we pair translators that are experienced in your use case.",
} as const;

const useCasesCards: CasesCardProps[] = [
  {
    title: "Academic",
    description:
      "Translate academic transcripts, diplomas, and records with certified accuracy for university admissions and international education requirements.",
    imageUrl: images.imgUseCase1,
    link: "use-cases/academic",
    linkLabel: "Review",
  },
  {
    title: "Financial",
    description:
      "Specialized translations for financial reports, statements, and documents that maintain technical integrity, and regulatory precision.",
    imageUrl: images.imgUseCase2,
    link: "use-cases/financial",
    linkLabel: "Review",
  },
  {
    title: "Immigration (USCIS)",
    description:
      "Expert translation, certification, and notarization services for personal documents, meeting strict requirements for USCIS and immigration acceptance.",
    imageUrl: images.imgUseCase3,
    link: "use-cases/uscis-immigration",
    linkLabel: "Review",
  },
  {
    title: "Legal",
    description:
      "Precise and secure certified translations for legal documents ensuring accuracy, and compliance in global legal proceedings.",
    imageUrl: images.imgUseCase4,
    link: "use-cases/legal",
    linkLabel: "Review",
  },
  {
    title: "Localization",
    description:
      "Languex adapts websites, apps, software, marketing content, and more for global audiences, ensuring cultural relevance and seamless experiences.",
    imageUrl: images.imgUseCase5,
    link: "use-cases/localization",
    linkLabel: "Review",
  },
  {
    title: "Marketing",
    description:
      "Localize marketing content that resonates across global markets, while preserving brand voice and cultural nuance.",
    imageUrl: images.imgUseCase6,
    link: "use-cases/marketing",
    linkLabel: "Review",
  },
  {
    title: "Scientific",
    description:
      "Languex translates research papers, lab reports, technical studies, and more, ensuring precise scientific terminology and accuracy.",
    imageUrl: images.imgUseCase7,
    link: "use-cases/scientific",
    linkLabel: "Review",
  },
  {
    title: "Technical",
    description:
      "Convert technical documents with precision and correct technical terminology and understanding of concepts.",
    imageUrl: images.imgUseCase8,
    link: "use-cases/technical",
    linkLabel: "Review",
  },
  {
    title: "Customer Support",
    description:
      "Languex translates emails, live chat, FAQs, support tickets, and more, ensuring clear multilingual communication for global customers.",
    imageUrl: images.imgUseCase9,
    link: "use-cases/customer-support",
    linkLabel: "Review",
  },
  {
    title: "HR",
    description:
      "We translate employee handbooks, training materials, policies, and more, ensuring compliance and consistency across global teams.",
    imageUrl: images.imgUseCase10,
    link: "use-cases/hr",
    linkLabel: "Review",
  },
  {
    title: "Medical",
    description:
      "Provide precise, HIPAA-compliant translations for medical documents, research, and patient communications across healthcare sectors.",
    imageUrl: images.imgUseCase11,
    link: "use-cases/medical",
    linkLabel: "Review",
  },
  {
    title: "Professional Services",
    description:
      "We translate contracts, reports, client communications, and more, ensuring accurate industry-specific language for global businesses.",
    imageUrl: images.imgUseCase12,
    link: "use-cases/professional-services",
    linkLabel: "Review",
  },
];

export const useCasesCardsData = {
  ...useCasesCardsContent,
  cards: useCasesCards
};
